<div class="link-container">
  <a [routerLink]="[link]" [matTooltip]="backwardTitle ?? ''" class="td-n backward-link">
    <svg [icon]="icons.ArrowRight" class="svg24 dark-gray-color arrow-icon"></svg>
  </a>
  <p
    *ngIf="!templateRef && defaultTooltip"
    class="h3 m0 title"
    [style.max-height]="height | px"
    [style.max-width]="width | px"
    [matTooltip]="titleName ?? ''"
  >
    {{ titleName ?? '' }}
  </p>

  <p
    *ngIf="!templateRef && !defaultTooltip"
    class="h3 m0 title"
    #title
    [style.max-height]="height | px"
    [style.max-width]="width | px"
    [toolTipWidth]="customTooltipWidth"
    [toolTipOffsetY]="-2"
    [customToolTip]="titleName ?? ''"
  >
    {{ titleName ?? '' }}
  </p>
</div>

<ng-container *ngIf="templateRef">
  <ng-container *ngTemplateOutlet="templateRef"></ng-container>
</ng-container>
